<div mat-dialog-title>
    <div class="row">
      <div class="col-6 col-md-6">
        <h1 class="form-title-heading" style="text-transform: uppercase;">{{title ? title : 'IMPORT .CSV'}}</h1>
      </div>
      <div class="col-6 col-md-6 text-end">
        <a (click)="this.close()" class="clickable">
          <img src="/assets/cancel-icon-alt.png" alt="cancel-icon" />
        </a>
      </div>
    </div>
  </div>
  

<div mat-dialog-content class="row">
    <div class="col-12 col-md-12 mb-30">
        <div class="upload-image-placeholder" intrasenseDragNDrop (fileDropped)="onUploadFile($event, true)">
            <ng-container *ngIf="fileCtrl.value">
                <div class="uploaded-images-container">
                    <div class="uploaded-image-prev">
                        <img src="/assets/csv-upload.png" alt="id_proof_image" referrerpolicy="no-referrer" class="image-preview" (click)="previewImage()">
                        <img src="/assets/upload_close.svg" alt="close_icon" referrerpolicy="no-referrer" class="image-preview-close" (click)="removeImage()">
                    </div>
                    <button mat-flat-button type="button" class="btn-secondary btn-medium" (click)="uploadIdentityFile1.click()">Upload File</button>
                    <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display: none" (change)="onUploadFile($event)" #uploadIdentityFile1>
                </div>
            </ng-container>

            <ng-container *ngIf="!fileCtrl.value">
                <div class="d-flex flex-row align-self-center justify-content-center align-items-center flex-wrap upload-image-button">
                    <div class="mx-2"><span><img src="/assets/menu-icon/upload-imge-icon.png" alt="upload-icon" class="upload-icon"></span></div>
                    <div class="mx-2"><span class="upload-image-title">Drag and Drop File here or </span></div>
                    <div class="mx-2">
                        <button mat-flat-button type="button" class="btn-secondary btn-medium" (click)="uploadIdentityFile.click()">Upload File</button>
                    </div>
                    <input type="file" accept=".csv" (change)="onUploadFile($event, false)" hidden #uploadIdentityFile>
                </div>
            </ng-container>

        </div>
        <div *ngIf="submitAttempted && !fileCtrl.value" class="error-message">
            Please select a file to upload.
          </div>
    </div>
    <div class="col-12 col-md-12 mt-50 text-center">
        <button mat-flat-button class="btn-large btn-primary" (click)="uploadCSV()">IMPORT</button>
    </div>
</div>